import {
  COMPANY_SIGN_IN_CONSENT_RESULT_PARAM,
  COMPANY_SIGN_IN_SETTINGS_PATH,
  COMPANY_SIGN_IN_TEST_RESULT_PARAM,
  type SignInClient,
  type SsoProviderSlug,
} from '@instanexus/contracts';
import type { ApiClient } from '@instanexus/sdk';

import { saveFederatedReturn } from '@/lib/federated-return';
import { clientAppOrigin } from '@/lib/sign-in-request';

/** `<app origin>/settings/company-sign-in?companyTest=<passed|CODE>`, or null when the build has no URL for the app. */
export function companySignInSettingsUrl(client: SignInClient, result: string): string | null {
  const origin = clientAppOrigin(client);
  if (origin === null) return null;
  const url = new URL(COMPANY_SIGN_IN_SETTINGS_PATH, origin);
  url.searchParams.set(COMPANY_SIGN_IN_TEST_RESULT_PARAM, result);
  return url.toString();
}

/** `<app origin>/settings/company-sign-in?companyConsent=<granted|CODE>`, or null when the build has no URL for the app. */
export function companySignInConsentSettingsUrl(
  client: SignInClient,
  result: string,
): string | null {
  const origin = clientAppOrigin(client);
  if (origin === null) return null;
  const url = new URL(COMPANY_SIGN_IN_SETTINGS_PATH, origin);
  url.searchParams.set(COMPANY_SIGN_IN_CONSENT_RESULT_PARAM, result);
  return url.toString();
}

/** An admin's company test sign-in: saves the return, starts the test and leaves for the provider. */
export async function startCompanySignInTest(
  api: Pick<ApiClient, 'federation'>,
  provider: SsoProviderSlug,
  client: SignInClient,
  redirectTo: (url: string) => void,
  storage?: Storage,
): Promise<void> {
  saveFederatedReturn({ kind: 'company_test', client }, storage);
  const { authorizeUrl } = await api.federation.startCompanyTest(provider);
  redirectTo(authorizeUrl);
}
